import { StatusEnum } from '@wheere/api-tracker';
import { SiteType } from '@wheere/api-site';

export function transformStatusEnumToArray(): Array<{ label: string; value: StatusEnum }> {
  return Object.values(StatusEnum).map(status => ({
    label: status.charAt(0).toUpperCase() + status.slice(1).toLowerCase(), // Capitalize the label
    value: status,
  }));
}

export function transformSiteTypeToArray(): Array<{ label: string; value: SiteType }> {
  return Object.values(SiteType).map(value => ({
    label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
    value: value,
  }));
}
